var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-alert',{class:['my-4', 'unselectable'],attrs:{"value":true,"color":_vm.color,"dismissible":_vm.dismissible,"icon":_vm.icon,"outline":_vm.outline}},[_vm._v(_vm._s(_vm.message))])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3a2a3370","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/warning.vue
// module id = null
// module chunks = 